<template>
    <div class="artDelVerify">
        <div class="artDelHolder">
            <i id="delete-confirmation__close-button" class="material-icons" @click="closeDel">close</i>
            <form class="artDelForm">

                <p class="artQuestion">Are you sure about deleting {{artDetail.artnum}}?</p>
                <input class="artDelInput" type="password" placeholder="password" v-model="pw">
                <button class="artDelButton" @click.prevent="delArt">del</button>
            </form>
        </div>
    </div>
</template>

<script>

export default {
    data() {
        return {
            pw: ''
        }
    },
    computed: {
        artDetail() {
            return this.$store.getters['fotodatenbank/artDetails'];
        }

    },
    methods: {
        delArt() {
            this.$store.dispatch('fotodatenbank/delArt', this.pw);
        },
        closeDel() {
            this.$router.go(-1);
        }

    }
}
</script>

<style scoped lang="scss">

#delete-confirmation__close-button{
    position: absolute;
    top:0;
    right:0;
    cursor: pointer;
    font-size: 2.5rem;
}

.artDelVerify{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    /* background-color: blue; */
    z-index: 900;

}

.artDelHolder{
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    /*height: 12.5rem;*/
    background-color: $color-white;
    @include default-shadow;
    padding-top: 0.625rem;
    padding-bottom: 0.625rem;
}

.artDelForm{
    display:flex;
    flex-direction: column;
    justify-content: center;
    margin-left: 1.25rem;
    margin-right: 2.5rem;
}

.artDelInput{
    font-size: 1.25rem;

}

.artQuestion{
    font-size: 1rem;
}

@include medium{
    .artDelHolder{
        width: 31rem;
    }
    .artQuestion{
        font-size: 1.25rem;
    }
}

@include extra-large{
    .artDelHolder{
        width: 700px;
    }

    .artDelInput{
        font-size: 2rem;

    }

    .artDelButton{
        font-size: 2.5rem;
    }

    .artQuestion{
        font-size: 1.5rem;
    }

}

</style>
